export const toggleReviewPopup = () => {
	const openPopupBtn = document.getElementById('reviewPopupOpen');
	const closePopupBtn = document.getElementById('reviewPopupClose');
	const popup = document.querySelector('.reviewForm__popup');

	openPopupBtn.addEventListener('click', () => {
		popup.classList.add('visible');
	});

	closePopupBtn.addEventListener('click', () => {
		popup.classList.remove('visible');
	});
}